<template>
  <el-form-item label="商机名称：" prop="businessId">
    <el-select
      clearable
      filterable
      remote
      reserve-keyword
      placeholder="请选择客户名称"
      @focus="handleSelectBlur"
      @change="handleSelectChange"
      @clear="handleSelectClear"
      :remote-method="handleBusinessSearch"
      :loading="selectData.loading"
      :value="searchBusiness">
      <el-option
        v-for="(item) in selectList"
        :label="item.name"
        :value="item.id"
        :key="item.id">
         <span style="float: left" class="select-item-left">{{item.name}}</span>
          <!-- <div v-if="[item.name, item.hospitalName,item.hospDeptName,item.hospDeptName].filter(Boolean).join('-').length > 40">
            <el-tooltip
              class="item custom-select-item"
              effect="dark"
              :content="[item.name, item.hospitalName,item.hospDeptName].filter(Boolean).join('-')"
              placement="top">
              <span style="float: left" class="select-item-left">{{ [item.name, item.hospitalName].filter(Boolean).join('-') }}</span>
            </el-tooltip>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.hospDeptName }}</span>
          </div>
        <div v-else>
          <span style="float: left" class="select-item-left">{{ [item.name, item.hospitalName].filter(Boolean).join('-') }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.hospDeptName }}</span>
        </div> -->
      </el-option>
      <el-option
        v-if="visitBusinessDataList.totalCount > selectData.pageSize && selectData.pageIndex < visitBusinessDataList.totalPages"
        label="点击加载更多"
        value="点击加载更多"
        :disabled="true"
        style="cursor:pointer;">
        <span @click="handleMoreBusinessList()">点击加载更多</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    val: {
      type: String,
      default: '',
    },
    // uid: {
    //   type: String,
    //   default: '',
    // },
  },
  data() {
    return {
      isMore: false,
      selectData: {
        loading: false,
        query: '',
        pageIndex: 1,
        pageSize: 5,
      },
      selectList: [],
    };
  },
  computed: {
    ...mapGetters({
      visitBusinessDataList: 'visit/visitBusinessDataList',
    }),
    searchBusiness() {
      return this.val || this.selectData.query;
    },
  },
  watch: {
    selectList(val) {
      // this.$emit('listDataChange', val);
    },
  },
  methods: {
    ...mapActions({
      getVisitBusinessDataList: 'visit/getVisitBusinessDataList',
    }),
    handleSelectBlur() {
      if (this.val) return;
      this.selectData.pageIndex = 1;
      this.selectData.query = '';
      this.getBusinessSelectList();
    },
    handleSelectChange(value) {
      this.$emit('change', value);
    },
    handleSelectClear() {
      this.selectData.query = '';
    },
    handleBusinessSearch(query) {
      this.selectData.query = query;
      this.selectData.pageIndex = 1;
      this.getBusinessSelectList();
    },
    getBusinessSelectList() {
      this.getVisitBusinessDataList({
        // uid: this.uid,
        name: this.selectData.query,
        pageSize: this.selectData.pageSize,
        pageNumber: this.selectData.pageIndex,
      }).then(() => {
        if (this.selectData.pageIndex === 1) {
          this.selectList = [];
        }
        this.visitBusinessDataList.results.forEach((item) => {
          this.selectList.push(item);
        });
      });
    },
    handleMoreBusinessList() {
      this.isMore = true;
      this.selectData.pageIndex += 1;
      this.getBusinessSelectList();
    },
  },
};
</script>
